"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var assessment_method_selection_card_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/assessment_method_selection_card"));
var AI_ASSESSMENT_URL = '/lp/aisatei/form/';
var AssessmentMethodSelectionStore = /** @class */ (function () {
    function AssessmentMethodSelectionStore(props) {
        var _this = this;
        this.component = assessment_method_selection_card_1.default;
        this.handleClickAiAssessment = function () {
            var targetUrl = new URL(AI_ASSESSMENT_URL, window.location.origin);
            var ref = new URLSearchParams(window.location.search).get('ref');
            if (ref) {
                targetUrl.searchParams.set('ref', ref);
            }
            window.location.href = targetUrl.toString();
        };
        this.handleClickSelfInput = function () {
            _this.onSelectSelfInput();
        };
        this.onSelectSelfInput = props.onSelectSelfInput;
    }
    return AssessmentMethodSelectionStore;
}());
exports.default = AssessmentMethodSelectionStore;
